/* eslint-disable import/prefer-default-export */
import { Mailcheck } from '../vendor/mailcheck';

export const emailCorrectionSuggestion = (email: string) => {
  const suggestion = Mailcheck.run({
    email,
  });

  return suggestion?.full;
};

export const validateEmail = (email: string) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};
